export function useKioskUserSwitch(options: {
  rfid: string | Ref<string>;
  onSameUserRescan?: () => void;
  onBeforeSwitch?: () => void;
}) {
  const user = useUserStore();

  const handlePlayerScanned = async (event: Event) => {
    const data = event as CustomEvent;
    if (!data.detail) return;

    const rfidValue = unref(options.rfid);
    if (!rfidValue) return;

    if (
      data.detail.rfidScannerCode?.toLowerCase() !== rfidValue.toLowerCase()
    ) {
      return;
    }

    // Same user re-scan: reset timeout only
    if (data.detail.playerId === user.playerId) {
      options.onSameUserRescan?.();
      return;
    }

    // Different user: full switch
    options.onBeforeSwitch?.();

    if (user.loggedIn) await user.logout();
    await user.loginWithKey(data.detail.key, data.detail.playerId);

    const { startInactivityTimeout } = useKioskTimeout();
    startInactivityTimeout();

    if (user.kioskAccessed) {
      // Force full page reload to reset all state cleanly
      window.location.href = `/home?mode=kiosk&rfid=${rfidValue}&key=${data.detail.key}&id=${data.detail.playerId}`;
    } else {
      navigateTo(`/setup?key=${data.detail.key}&id=${data.detail.playerId}`);
    }
  };

  onMounted(() => {
    document.addEventListener("player-scanned", handlePlayerScanned);
  });

  onUnmounted(() => {
    document.removeEventListener("player-scanned", handlePlayerScanned);
  });
}
